// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"W5-z"};